module.exports = __webpack_public_path__ + "static/media/golf-scope.f9a70184.png";